<style >
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.activeClass{
  background: #fff!important;
}
</style>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Müşteri Sayısı",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
        title: "MÜŞTERİ SAYISI",
        items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "MÜŞTERİ SAYISI",
          active: true,
        },
      ],
      isLoading: false,
      form: {},
      rows: {}
    };
  },
  mounted() {
    this.loadItems()
  },
  computed: {
    totalSums() {
      const result = {
        1: 0, // Günü Olan Aktifler
        2: 0, // Günü Olmayan
        3: 0, // İptal
        4: 0, // Dondurulmuş
      };

      for (const firma in this.rows) {
        const tariffGroups = this.rows[firma];
        for (const tarif in tariffGroups) {
          const statusCounts = tariffGroups[tarif];
          for (const status in statusCounts) {
            const statusInt = parseInt(status);
            if (result[statusInt] !== undefined) {
              result[statusInt] += statusCounts[statusInt];
            }
          }
        }
      }

      return result;
    }
  },
  methods: {
    loadItems() {
      this.$http.post('/reports/sayilar')
        .then(response => { 
                      
          const data = Object.values(response.data); // <-- Diziye çeviriyoruz
          const grouped = {};

          data.forEach(item => {
            const firma = item.firma;
            const tarif = item.tariff_group;
            const status = item.status;
            
            if (!grouped[firma]) {
              grouped[firma] = {};
            }

            if (!grouped[firma][tarif]) {
              grouped[firma][tarif] = {};
            }
            
            grouped[firma][tarif][status] = item.count;
          });
            
          this.rows = grouped;
        })
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
           <div v-for="(tariffGroups, firma) in rows" :key="firma" class="mb-10">
            <h2 class="text-lg font-bold p-2 mb-0">{{ firma }}</h2>
              <div class="table-responsive">
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                    <th class="">Tarife Türü</th>
                    <th class="">Günü Olan Aktifler</th>
                    <th class="">Günü Olmayan</th>
                    <th class="">Dondurulmuş</th>
                    <th class="">İptal</th>
                    <!-- Gerekirse diğer status başlıklarını da ekle -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(statusCounts, tarif) in tariffGroups" :key="tarif">
                    <td class="">{{ tarif }}</td>
                    <td class="">{{ statusCounts[1] || 0 }}</td>
                    <td class="">{{ statusCounts[2] || 0 }}</td>
                    <td class="">{{ statusCounts[4] || 0 }}</td>
                    <td class="">{{ statusCounts[3] || 0 }}</td>
                    <!-- Diğer status sütunları -->
                    </tr>
                  </tbody>
                <tfoot>
                    <tr class="font-bold bg-gray-100">
                      <td> <strong>Toplam</strong></td>
                      <td>
                        <strong>{{
                          Object.values(tariffGroups).reduce((sum, statusCounts) => sum + (statusCounts[1] || 0), 0)
                        }}
                        </strong>
                      </td>
                      <td>
                        <strong>{{
                          Object.values(tariffGroups).reduce((sum, statusCounts) => sum + (statusCounts[2] || 0), 0)
                        }}</strong>
                      </td>
                      <td>
                        <strong>{{
                          Object.values(tariffGroups).reduce((sum, statusCounts) => sum + (statusCounts[4] || 0), 0)
                        }}</strong>
                      </td>
                      <td>
                        <strong>{{
                          Object.values(tariffGroups).reduce((sum, statusCounts) => sum + (statusCounts[3] || 0), 0)
                        }}</strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
        </div>

        <div class="card mt-5">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead>
                <tr class="bg-dark text-white">
                  <th class=""> GENEL TOPLAM</th>
                  <th class="">Günü Olan Aktifler</th>
                  <th class="">Günü Olmayan</th>
                  <th class="">Dondurulmuş</th>
                  <th class="">İptal</th>
                </tr>
              </thead>
              <tbody>
                <tr class="font-bold bg-gray-100">
                  <td>Toplam</td>
                  <td>{{ totalSums[1] }}</td>
                  <td>{{ totalSums[2] }}</td>
                  <td>{{ totalSums[4] }}</td>
                  <td>{{ totalSums[3] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  </Layout>
</template>